import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
//import Translations from '../translations/translations';
import { TranslationsApi } from '../api/TranslationsApi';

const addLanguageResource = (language, resources) => {
    i18next.addResourceBundle(language, 'translation', resources, false, true);
};

const loadTranslations = async () => {
    const fetchTranslationsSuccess = (resources) => {
        resources.forEach((lng) => {
            addLanguageResource(lng.Language, lng.Resources);
            lng.Language === 'de' && addLanguageResource('at', lng.Resources);
        });
    };

    const fetchTranslationsFailure = (error) => {
        console.log(error);
    };

    await new TranslationsApi().getTranslations(
        fetchTranslationsSuccess,
        fetchTranslationsFailure
    );
};

export const initI18n = async () => {
    await i18next.use(initReactI18next).use(LanguageDetector).init({
        debug: true,
        fallbackLng: 'en',
        lowerCaseLng: true,
        resources: {}
    });
    await loadTranslations();
};
